
/**
 * æå¡å¨ç«¯å¼å¸¸å®ä½
 */
class ServerExceptionEntity {

  Code: string;

  Level: ExceptionLevel;

  Message: string;

  Detail: string;

  RequestId: string;

  date?: string;

  innerMessage?: string;

}

/**
 * æå¡å¨ç«¯å¼å¸¸ç­çº§
 */
const enum ExceptionLevel {

  /**
   * æç¤ºä¿¡æ¯
   */
  Info = 0,

  /**
   * è­¦å
   */
  Warning,

  /**
   * éè¯¯
   */
  Error,

  /**
   * è´å½éè¯¯
   */
  Fatal
}

export { ServerExceptionEntity, ExceptionLevel };
